import { render, staticRenderFns } from "./OrganisationAdmin.vue?vue&type=template&id=afa27550&scoped=true"
import script from "./OrganisationAdmin.vue?vue&type=script&lang=js"
export * from "./OrganisationAdmin.vue?vue&type=script&lang=js"
import style0 from "./OrganisationAdmin.vue?vue&type=style&index=0&id=afa27550&prod&lang=scss"
import style1 from "./OrganisationAdmin.vue?vue&type=style&index=1&id=afa27550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa27550",
  null
  
)

export default component.exports